// apps/web/src/features/dashai/lib/workflowUrlSlugs.ts
//
// Bidirectional mapping between URL-facing workflow slugs and the internal
// workflow agent ids. The internal id is load-bearing (deck types, switch
// cases, saved canvases, DB visibility rows), so we don't rename it. Instead
// the URL layer uses a friendlier slug that's safer to show clients.

// id -> url-slug. Falls back to the id itself if no entry exists.
const ID_TO_URL: Record<string, string> = {
  'platform-distribution-gaps': 'cross-platform-brand-gaps',
  'pack-type-gaps': 'can-vs-bottle-pack-gaps',
};

// url-slug -> id. Built from ID_TO_URL so the two stay in sync.
const URL_TO_ID: Record<string, string> = Object.fromEntries(
  Object.entries(ID_TO_URL).map(([id, slug]) => [slug, id]),
);

export function workflowUrlSlug(agentId: string | undefined): string {
  if (!agentId) return '';
  return ID_TO_URL[agentId] ?? agentId;
}

export function workflowIdFromUrlSlug(slug: string | undefined): string | undefined {
  if (!slug) return undefined;
  return URL_TO_ID[slug] ?? slug;
}
